/* Actions Doctipro de haut niveau : extension si présente, sinon repli favoris (bookmarklets). */
import { toast } from 'sonner';
import { appelerExtension, extensionVersion } from './extensionDoctipro';
import { enregistrerPatientDoctipro, lirePatientDoctipro, preparerTexteDoctipro } from './passerelleDoctipro';
import { demanderOngletDoctipro } from '../components/doctipro/ChoixOngletDoctipro';

const ANNULE = Symbol('annule');

// Plusieurs onglets Doctipro → choix ; collage → confirmation du patient. Extension 1.0 : comportement d'origine.
const choisirOnglet = async (mode, titre) => {
  const rep = await appelerExtension('listerOnglets');
  if (!rep.ok || !Array.isArray(rep.onglets)) return undefined;
  if (!rep.onglets.length) return undefined;
  if (rep.onglets.length === 1 && mode === 'lire') return rep.onglets[0].tabId;
  const tabId = await demanderOngletDoctipro({ mode, titre, onglets: rep.onglets });
  return tabId ?? ANNULE;
};

export const recupererPatientDoctipro = async () => {
  const tabId = await choisirOnglet('lire');
  if (tabId === ANNULE) return null;
  const rep = await appelerExtension('lirePatient', { tabId });
  if (!rep.ok) { toast.error(rep.erreur || 'Lecture Doctipro impossible'); return null; }
  enregistrerPatientDoctipro(rep.texte, rep.source || 'doctipro');
  const p = lirePatientDoctipro();
  const nom = [p?.infos?.nom, p?.infos?.prenom].filter(Boolean).join(' ') || 'patient';
  toast.success(`Patient Doctipro récupéré : ${nom} — vérifiez les champs`);
  return p;
};

export const envoyerTexteDoctipro = async (texte, titre, { afficher = true, cible = '' } = {}) => {
  preparerTexteDoctipro(texte, titre);
  if (!extensionVersion()) {
    toast.success(`${titre} — texte préparé : sur Doctipro, cliquez dans le champ puis sur le favori « OphtaPilot → Doctipro »`);
    return false;
  }
  const tabId = await choisirOnglet('coller', titre);
  if (tabId === ANNULE) { toast.info('Envoi vers Doctipro annulé'); return false; }
  const rep = await appelerExtension('collerTexte', { texte, afficher, tabId, cible });
  if (!rep.ok) { toast.error(rep.erreur || 'Collage dans Doctipro impossible'); return false; }
  toast.success(rep.champ ? `${titre} collé dans le champ « ${rep.champ} » de Doctipro` : `${titre} collé dans Doctipro`);
  return true;
};

/** Codes de nomenclature (ex. "C16 YFQ13 YBQ11R") → ligne « Ajouter des codes » de la mémoire d'honoraires Doctipro, puis « Insérer ». */
export const envoyerCodesDoctipro = async (codes) => {
  const texte = String(codes || '').replace(/[,;\n]+/g, ' ').replace(/\s+/g, ' ').trim();
  if (!texte) { toast.error('Aucun code à envoyer'); return false; }
  if (!extensionVersion()) { toast.error('Extension OphtaPilot non détectée : installez-la depuis Mon profil pour insérer les codes dans Doctipro.'); return false; }
  const tabId = await choisirOnglet('coller', 'Codes de facturation');
  if (tabId === ANNULE) { toast.info('Envoi vers Doctipro annulé'); return false; }
  const rep = await appelerExtension('collerCodes', { codes: texte, tabId });
  if (!rep.ok) {
    toast.error(/^Action inconnue/.test(rep.erreur || '') ? 'Mettez à jour l\'extension OphtaPilot (v1.2.4) depuis Mon profil pour envoyer les codes.' : (rep.erreur || 'Insertion des codes dans Doctipro impossible'));
    return false;
  }
  if (rep.restant) toast.warning(`Codes saisis dans Doctipro (${texte}) — cliquez sur « Insérer » si les lignes n'apparaissent pas.`);
  else toast.success(`Codes insérés dans Doctipro : ${texte}`);
  return true;
};
